@if(suggestionList()) {
  
  <app-box-1
    [padding]="32"
    [borderWidth]="2"
    [borderRadius]="32"
    [backgroundColor]="'#00000060'"
    [backdropFilterBlur]="24"
  >
    <section class="suggestions">
      <h2 class="suggestions__title ci-heading-h1-bold">
        {{ 'Otras recomendaciones en tu ruta' | translate }}
      </h2>
      
      <app-box-1
        class="suggestions__box"
        [padding]="16"
        [borderWidth]="1"
        [borderRadius]="16"
        [backgroundColor]="'#00000040'"
        [backdropFilterBlur]="24"
      >
        <ul class="suggestions__category-list">
          <li class="category-list__category">
              @for(category of suggestionList().data; track category.id) {
              <section class="category-list__section">
                <h3 class="category-list__title">
                  {{ category.name[this.selectedLanguage()] }}
                </h3>
                <ul class="category-list__point-list">
                  @for(item of category.points; track item.id; let index = $index) {
                    <li class="point-list__item">
                      <app-card-1 
                        class="item__card"
                        [indexCard]="index"
                        [id]="item.id"
                        [title]="item.name[this.selectedLanguage()]"
                        [img]="getFirstImageFromMultimediaList(item.multimedia)"
                        [numberOfPoints]="suggestionList().data.length"
                        (click)="goToDetailPage(item.id, item.type, 'suggestions')"
                      ></app-card-1>
                    </li>
                  }
                </ul>
              </section>
            }
          </li>
        </ul>
      </app-box-1>
    </section>
  </app-box-1>
}
